import { getType } from 'typesafe-actions'
import { cloneDeep } from 'lodash'

import * as actions from './actions'
import { StoreState, ReportCommonAction } from './types'
import produce from 'immer'
import parseErrorMessage from 'utils/parseErrorMessage'
import { Event } from '../../types/event'

const initEvent = {
  IsLoading: false,
  MessageSuccess: undefined,
  SubmitError: undefined,
  SubmitSuccess: false,
  SubmitType: undefined,
} as Event

const initialState: StoreState = {
  event: cloneDeep(initEvent),
}

export default function(
  state: StoreState = initialState,
  action: ReportCommonAction
): StoreState {
  return produce(state, draft => {
    switch (action.type) {
      case getType(actions.saveSignatureAction.request):
      case getType(actions.saveZoneSignatureAction.request):
      case getType(actions.saveCommissionSignatureAction.request):
      case getType(actions.saveConstructPlanSignatureAction.request):
      case getType(actions.saveAuditPlanSignatureAction.request):
      case getType(actions.saveConstructRoadSignatureAction.request):
      case getType(actions.saveAuditRoadSignatureAction.request):
      case getType(actions.enableFunctionAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        break

      case getType(actions.saveSignatureAction.failure):
      case getType(actions.saveZoneSignatureAction.failure):
      case getType(actions.saveCommissionSignatureAction.failure):
      case getType(actions.saveConstructPlanSignatureAction.failure):
      case getType(actions.saveAuditPlanSignatureAction.failure):
      case getType(actions.saveConstructRoadSignatureAction.failure):
      case getType(actions.saveAuditRoadSignatureAction.failure):
      case getType(actions.enableFunctionAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        break

      case getType(actions.saveSignatureAction.success):
      case getType(actions.saveZoneSignatureAction.success):
      case getType(actions.saveCommissionSignatureAction.success):
      case getType(actions.saveConstructPlanSignatureAction.success):
      case getType(actions.saveAuditPlanSignatureAction.success):
      case getType(actions.saveConstructRoadSignatureAction.success):
      case getType(actions.saveAuditRoadSignatureAction.success):
      case getType(actions.enableFunctionAction.success):
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'ทำรายการสำเร็จ'
        break
      case getType(actions.resetEvent):
        draft.event = cloneDeep(initEvent)
        break
      default:
        return state
    }
  })
}
